var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-dialog', {
    attrs: {
      "title": "면접거부 상세",
      "maxWidth": "400",
      "hideActions": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true)
  }, [_c('div', {
    staticClass: "mb-4 mb-lg-8"
  }, [_vm._v("거부사유: " + _vm._s(_vm.value.refuseMsg))]), _c('span', {
    staticClass: "page-text--sm grey-9--text"
  }, [_vm._v(" 거부일시: " + _vm._s(_vm.value.refusedAt.toDateTime()) + " ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }